import api from './api';

const adminApplicationsService = {
  list: (params = {}) => api.get('/admin/applications', { params }).then((r) => r.data),
  detail: (id) => api.get(`/admin/applications/${id}`).then((r) => r.data),
  counts: () => api.get('/admin/applications/counts').then((r) => r.data),
  approve: (id, verifierTypes) => api.post(`/admin/applications/${id}/approve`,
    Array.isArray(verifierTypes) ? { verifierTypes } : {}).then((r) => r.data),
  setVerifierTypes: (id, verifierTypes) => api.patch(`/admin/applications/${id}/verifier-types`, { verifierTypes }).then((r) => r.data),
  reject: (id, reason) => api.post(`/admin/applications/${id}/reject`, { reason }).then((r) => r.data),
  unapprove: (id) => api.post(`/admin/applications/${id}/unapprove`).then((r) => r.data),
  approveDocument: (docId) => api.post(`/admin/documents/${docId}/approve`).then((r) => r.data),
  rejectDocument: (docId, reason) => api.post(`/admin/documents/${docId}/reject`, { reason }).then((r) => r.data),
  remind: (id) => api.post(`/admin/applications/${id}/remind`).then((r) => r.data),
  remindIncomplete: (role) => api.post('/admin/applications/remind-incomplete',
    role && role !== 'all' ? { role } : {}).then((r) => r.data),
  getKycSettings: () => api.get('/admin/kyc-settings').then((r) => r.data),
  setKycSettings: (contractorKycRequired) => api.patch('/admin/kyc-settings', { contractorKycRequired }).then((r) => r.data),
  waiveDocuments: (userId, waived, reason) => api.post(`/admin/users/${userId}/waive-documents`, { waived, reason }).then((r) => r.data),
  waiveRequirement: (id, key, waived, reason) =>
    api.post(`/admin/applications/${id}/waive-requirement`, { key, waived, reason }).then((r) => r.data),
  // Merchant tier-upgrade requests
  listTierUpgrades: () => api.get('/merchants/admin/tier-upgrades').then((r) => r.data),
  resolveTierUpgrade: (merchantId, approve) =>
    api.post(`/merchants/admin/tier-upgrades/${merchantId}/resolve`, { approve }).then((r) => r.data),
  // Merchant KYC documents (separate table from user_documents)
  listMerchantDocuments: (status = 'Pending') =>
    api.get('/merchants/admin/documents', { params: { status } }).then((r) => r.data),
  reviewMerchantDocument: (docId, decision, notes) =>
    api.post(`/merchants/admin/documents/${docId}/review`, { decision, notes }).then((r) => r.data),
  // Realtor: EAC register override + sync status
  setRealtorEacOverride: (userId, verified, notes) =>
    api.post(`/admin/realtors/${userId}/eac-override`, { verified, notes }).then((r) => r.data),
  /** Eqaya's own check: the agency confirmed (on its EAC-register contact) that the realtor works there. */
  setRealtorAgencyConfirmation: (userId, confirmed, notes) =>
    api.post(`/admin/realtors/${userId}/agency-confirmation`, { confirmed, notes }).then((r) => r.data),
  listEacSyncRuns: () => api.get('/admin/realtors/eac-sync-runs').then((r) => r.data),
  triggerEacSync: () => api.post('/admin/realtors/eac-sync').then((r) => r.data),
  // Conveyancer: Law Society register override + sync status
  setConveyancerLszOverride: (userId, verified, notes) =>
    api.post(`/admin/conveyancers/${userId}/lsz-override`, { verified, notes }).then((r) => r.data),
  listLszSyncRuns: () => api.get('/admin/conveyancers/lsz-sync-runs').then((r) => r.data),
  triggerLszSync: () => api.post('/admin/conveyancers/lsz-sync').then((r) => r.data),
};

export default adminApplicationsService;
